import React, { useState } from 'react'
import { useBranding } from '@/contexts/BrandingContext'
import { getPageStyles } from '@/utils/pageBranding'
import { DocumentUpload, DocumentList, KYCStatus } from '@/components/documents'
import { Upload, List, Shield } from 'lucide-react'

export const Documents: React.FC = () => {
  const { branding } = useBranding()
  const pageStyles = getPageStyles(branding)
  const [activeTab, setActiveTab] = useState<'status' | 'upload' | 'list'>('status')
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const handleUploadSuccess = () => {
    setRefreshTrigger(prev => prev + 1)
    setActiveTab('list')
  }

  const handleUploadError = (error: string) => {
    alert(error)
  }

  const handleStatusUpdate = () => {
    setRefreshTrigger(prev => prev + 1)
  }

  return (
    <div className="min-h-screen" style={pageStyles.container}>
      <div className="relative z-10 p-6">
        <div className="mb-8">
          <p className="text-lg" style={pageStyles.textSecondary}>
            Upload and manage your verification documents for KYC compliance.
          </p>
        </div>

        {/* Tab Navigation */}
        <div className="mb-8">
          <nav className="flex space-x-8">
            <button
              onClick={() => setActiveTab('status')}
              className={`py-3 px-4 border-b-2 font-semibold text-sm transition-all duration-300 flex items-center space-x-2 ${activeTab === 'status'
                ? 'border-transparent'
                : 'border-transparent hover:opacity-80'
                }`}
              style={{
                borderBottomColor: activeTab === 'status' ? branding.primaryColor : 'transparent',
                color: activeTab === 'status' ? branding.primaryColor : branding.textSecondaryColor
              }}
            >
              <Shield className="w-4 h-4" />
              <span>KYC Status</span>
            </button>
            <button
              onClick={() => setActiveTab('upload')}
              className={`py-3 px-4 border-b-2 font-semibold text-sm transition-all duration-300 flex items-center space-x-2 ${activeTab === 'upload'
                ? 'border-transparent'
                : 'border-transparent hover:opacity-80'
                }`}
              style={{
                borderBottomColor: activeTab === 'upload' ? branding.primaryColor : 'transparent',
                color: activeTab === 'upload' ? branding.primaryColor : branding.textSecondaryColor
              }}
            >
              <Upload className="w-4 h-4" />
              <span>Upload Document</span>
            </button>
            <button
              onClick={() => setActiveTab('list')}
              className={`py-3 px-4 border-b-2 font-semibold text-sm transition-all duration-300 flex items-center space-x-2 ${activeTab === 'list'
                ? 'border-transparent'
                : 'border-transparent hover:opacity-80'
                }`}
              style={{
                borderBottomColor: activeTab === 'list' ? branding.primaryColor : 'transparent',
                color: activeTab === 'list' ? branding.primaryColor : branding.textSecondaryColor
              }}
            >
              <List className="w-4 h-4" />
              <span>My Documents</span>
            </button>
          </nav>
        </div>

        {/* Tab Content */}
        <div className="space-y-6">
          {activeTab === 'status' && <KYCStatus onStatusUpdate={handleStatusUpdate} />}

          {activeTab === 'upload' && (
            <DocumentUpload
              onUploadSuccess={handleUploadSuccess}
              onUploadError={handleUploadError}
            />
          )}

          {activeTab === 'list' && <DocumentList key={refreshTrigger} />}
        </div>
      </div>
    </div>
  )
}
